import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { Layout, Drawer } from "antd";
import { MainHeader, VerticalMenu } from "./";
import Cookies from "universal-cookie";
import logoImage from "../assets/images/logo-da.png";

const { Content, Footer, Sider } = Layout;
const cookies = new Cookies();

const PrivateRoute: any = ({ children }: { children: JSX.Element }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.authentication.userData);
  const isLoggedIn = useSelector((state: any) => state.authentication.loggedIn);

  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [authChecked, setAuthChecked] = useState(false);

  // Check authentication on mount and when auth state changes
  useEffect(() => {
    const token = cookies.get('token');
    const cookieUserDataStr = cookies.get('userData');

    if (!token) {
      if (isLoggedIn) {
        dispatch({ type: "LOG_OUT" });
      }
      setAuthChecked(true);
    } else if (!isLoggedIn && cookieUserDataStr) {
      // Parse userData from JSON string
      try {
        const cookieUserData = typeof cookieUserDataStr === 'string'
          ? JSON.parse(cookieUserDataStr)
          : cookieUserDataStr;
        dispatch({ type: "SET_USER", payload: cookieUserData });
      } catch (error) {
        console.error('Failed to parse userData cookie:', error);
      }
      setAuthChecked(true);
    } else {
      setAuthChecked(true);
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMobileDrawerOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Check token existence
  const token = cookies.get('token');

  // If no token, redirect to login immediately
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Wait for auth check to complete
  if (!authChecked) {
    return null;
  }

  // If still not logged in after auth check, redirect
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const toggleSidebar = () => {
    if (isMobile) {
      setMobileDrawerOpen(!mobileDrawerOpen);
    } else {
      setCollapsed(!collapsed);
    }
  };

  const sidebarContent = (
    <>
      <a
        href="/"
        className="logo"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "16px",
          height: "64px",
        }}
      >
        <img
          src={logoImage}
          alt="Logo"
          style={{
            maxWidth: collapsed ? "48px" : "100%",
            transition: "all 0.2s",
          }}
        />
      </a>
      <VerticalMenu
        onMenuClick={() => isMobile && setMobileDrawerOpen(false)}
        collapsed={collapsed}
      />
    </>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {["admin", "superadmin", "referee", "leader"].includes(userData.role) && !isMobile && (
        <Sider
          collapsed={collapsed}
          width={250}
          collapsedWidth={80}
          style={{ backgroundColor: "#fff" }}
        >
          {sidebarContent}
        </Sider>
      )}
      {["admin", "superadmin", "referee", "leader"].includes(userData.role) && isMobile && (
        <Drawer
          placement="left"
          onClose={() => setMobileDrawerOpen(false)}
          open={mobileDrawerOpen}
          width={250}
          bodyStyle={{ padding: 0 }}
        >
          {sidebarContent}
        </Drawer>
      )}
      <Layout className="site-layout">
        <MainHeader setCollapsed={toggleSidebar} isMobile={isMobile} />
        <Content>{children}</Content>
        <Footer style={{ textAlign: "center" }}>
          Монголын Мөсөн Сурын Холбоо 2025 <br></br>
          DEVELOPED BY DIGITAL ARCHERY LLC
        </Footer>
      </Layout>
    </Layout>
  );
};

export default PrivateRoute;
